import type { FeatureFlag } from '@risksmart-app/modules/src/index';

/**
 * Control-test entity strings for the shared Smart Copy code — the single
 * per-entity source of truth a register supplies (keeps the shared code
 * entity-agnostic).
 *
 * - `flagKey` — per-org feature flag (`Meta.features`), read via
 *   `useIsFeatureFlagEnabled`; typed against the feature-flag registry.
 * - `eventLabel` — prefixes the Amplitude event names (capitalised); 'Control
 *   Test' reproduces the deployed strings.
 * - `entityNoun` — interpolates into the disabled tooltip (lowercase); 'test
 *   result' reproduces the deployed wording.
 */
export const CONTROL_TEST_SMART_COPY = {
  flagKey: 'smart_copy_control_test_result' satisfies FeatureFlag,
  eventLabel: 'Control Test',
  entityNoun: 'test result',
} as const;
